import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {ActivatedRoute} from "@angular/router";
import {Brand} from "./Brand";

@Injectable({
   providedIn: 'root'
})
export class InteresseFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService,
               private route: ActivatedRoute
   ) {
   }

   async getInteressi(vendorSlug=null):Promise<Interesse[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/interessi` : `/api/interessi`
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Interesse, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postInteresse(data, vendorSlug=null):Promise<Interesse[]> {
      let url = `/api/interessi`
      return new Promise((resolve, reject) => {
         ServerService.instance.post( url, data, Interesse).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putInteresse(interesseId, data):Promise<Interesse[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/interessi/${interesseId}`, data, Interesse).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteInteresse(interesseId):Promise<Interesse[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( `/api/interessi/${interesseId}`, {}, Interesse).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class InteresseData {
  id?: number;
  nome?: string;
}

export class Interesse {

  data:InteresseData = {}

  constructor(data:InteresseData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/interessi`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }



}
